<template>
  <ReportingLayout>
    <div style="margin: 15px;">
      <div class="px-4" style="min-width: 800px; max-width: 950px">
        <LocaleChanger
          class="noprint"
          :leftAlign="true"
          v-bind:emitRefresh="false"
          :key="'locale' + localeKey"
        />

        <Logo />

        <h2>{{ $t("report") }}</h2>
        <br />

        <NetworkError />

        <div
          v-if="
            showText &&
              !$store.state.main.playerIsOnlyFacilitator &&
              !$store.state.main.playerIsObserver
          "
          class="noprint"
        >
          {{ $t("reporthasbeenmailed") }}
          <br />
          <br />
        </div>

        <div v-if="!showChart || !showText">
          <div class="spinner-border" role="status"></div>
        </div>

        <ActionPlan
          v-if="showChart"
          :survey1Averages="survey1Averages"
          :survey2Averages="survey2Averages"
        />
        <br />
        <br />

        <div v-if="showChart" style="width: 100%; min-height: 400px">
          <div v-if="showText && selectedPlayer != 0">
            <h3>{{ $t("name") }} {{ playerName }}</h3>
            <br />
          </div>
          <h4 v-if="showText">{{ gameName }}</h4>
          <br />
          <h4 v-if="showText">{{ $t("date") }} {{ openDate }}</h4>
          <br />
          <div
            v-if="
              showText && $store.getters.getIsFacilitator && !$store.state.main.playerIsObserver
            "
            class="noprint"
          >
            {{ $t("selectplayer-explanation") }}
            <br />

            <base-dropdown>
              <base-button slot="title" type="secondary" class="dropdown-toggle">{{
                dropdowntext()
              }}</base-button>
              <a
                class="dropdown-item"
                @click="
                  selectedPlayer = 0;
                  generateCharts();
                "
                >{{ facilitatorDropdownText() }}</a
              >
              <div v-for="player in $store.getters.getPlayers" :key="player.id">
                <a
                  class="dropdown-item"
                  @click="
                    selectedPlayer = player.id;
                    generateCharts();
                  "
                  >{{ player.nick_name }}</a
                >
              </div>
            </base-dropdown>
            <br />
            <br />
          </div>

          <span v-if="!printMode">
            <a class="btn btn-secondary" :href="getUrl" target="_blank">{{
              $t("generateprintablereport")
            }}</a>
          </span>
          <base-button
            class="noprint"
            v-if="printMode && printImagesReady"
            type="secondary"
            style="margin: 2px"
            v-on:click="openPrintDialog()"
            >{{ $t("print") }}</base-button
          >
          <br />
          <base-button
            v-if="
              $store.getters.getIsFacilitator &&
                !this.$store.state.main.playerIsObserver &&
                !printMode
            "
            type="secondary"
            style="margin: 2px"
            v-on:click="exportToExcel()"
            >{{ $t("excel") }}</base-button
          >
          <br />
          <br />

          <div v-if="showText">
            <div
              v-if="getScenario.reporting_introduction"
              v-html="getScenario.reporting_introduction"
              style="max-width: 900px"
            ></div>
            <br />

            <h3>
              {{ getScenario.reporting_team_mean_preferences_title }}
            </h3>
            <div
              v-html="getScenario.reporting_team_mean_preferences_description"
              style="max-width: 900px"
            />
          </div>
          <br />
          <ECharts
            :initOptions="initOptions"
            ref="teamMostLiked"
            :options="teamMostLikedOptions"
            :autoresize="!printMode"
            :style="getEChartsStyle()"
          />

          <img
            :key="'teammostliked' + imagesComponentKey"
            v-if="printMode && printImagesReady"
            :src="teamMostLikedImage(imagesComponentKey)"
            width="1000"
          />

          <br />

          <div v-if="showText">
            <h3 style="page-break-before: always">
              {{ getScenario.reporting_connectivity_title }}
            </h3>
            <div v-html="getScenario.reporting_connectivity_description" style="max-width: 900px" />
          </div>
          <br />
          <ECharts
            :initOptions="initOptions"
            ref="connectivity"
            :options="connectivityOptions"
            :autoresize="!printMode"
            :style="getEChartsStyle()"
          />

          <img
            :key="'connectivity' + imagesComponentKey"
            v-if="printMode && printImagesReady"
            :src="connectivityImage(imagesComponentKey)"
            width="1000"
          />

          <br />
          <br />

          <div v-if="showText">
            <h3>{{ getScenario.reporting_diversity_title }}</h3>
            <div v-html="getScenario.reporting_diversity_description" style="max-width: 900px" />
          </div>
          <br />

          <ECharts
            :initOptions="initOptions"
            ref="minMax"
            :options="minMaxOptions"
            :autoresize="!printMode"
            :style="getEChartsStyle()"
          />

          <img
            v-if="printMode && printImagesReady"
            :src="minMaxImage(imagesComponentKey)"
            width="1000"
          />

          <div v-if="showText" style="margin-top: -20px">
            <table>
              <tr>
                <td style="width: 50px"></td>
                <td>
                  <div class="text-center">
                    {{ $t("diversitybar") }}<br />
                    <img
                      alt="SmoothTeam"
                      src="../assets/reporting-diversity.png"
                      height="50"
                    /><br />
                    {{ $t("diversityscatter") }}<br />
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <br />

          <div v-if="showText">
            <h3 style="page-break-before: always">
              {{ getScenario.reporting_team_self_awareness_title }}
            </h3>
            <div
              v-html="getScenario.reporting_team_self_awareness_description"
              style="max-width: 900px"
            />
          </div>
          <br />
          <ECharts
            :initOptions="initOptions"
            ref="teamSelfAwareness"
            :options="teamSelfAwarenessOptions"
            :autoresize="!printMode"
            :style="getEChartsStyle()"
          />

          <img
            v-if="printMode && printImagesReady"
            :src="teamSelfAwarenessImage(imagesComponentKey)"
            width="1000"
          />

          <div v-if="selectedPlayer">
            <div v-if="showText">
              <h3 v-if="getScenario.reporting_player_team_self_awareness_title">
                {{ getScenario.reporting_player_team_self_awareness_title }}
              </h3>
              <div
                v-html="getScenario.reporting_player_team_self_awareness_description"
                style="max-width: 900px"
              />
            </div>
            <br />
            <ECharts
              :initOptions="initOptions"
              ref="selectedPlayerTeamSelfAwareness"
              :options="selectedPlayerTeamSelfAwarenessOptions"
              :autoresize="!printMode"
              :style="getEChartsStyle()"
            />

            <img
              v-if="printMode && printImagesReady"
              :src="selectedPlayerTeamSelfAwarenessImage(imagesComponentKey)"
              width="1000"
            />
          </div>

          <br />

          <div v-if="showText && selectedPlayer > 0">
            <h3 style="page-break-before: always">
              {{ $t("playerselfevaluations") }}
            </h3>

            <div v-if="hasSelectedPlayerBeenNominated()">
              {{ $t("playernominations") }}
              <br />
            </div>

            <div
              class="list-group self-evaluation"
              v-for="(evaluation, index) in playerSelfEvaluations"
              :key="evaluation.caseId"
              v-bind:style="getBackgroundColor(index)"
            >
              <div :style="getTextColor(index)">
                {{ getQuestion(evaluation.case) }}
                {{ getNumberOfNominationsText(evaluation.case) }}
              </div>
            </div>

            <br />
            <br />

            <h3>{{ $t("yournominations") }}</h3>

            <div
              class="list-group"
              v-for="(nomination) in playerNominations"
              :key="nomination.id"
            >
              {{ getShortName(nomination.case) }}:
              {{ getNick(nomination.nominee) }}
            </div>
          </div>
          <br />

          <div v-if="showText">
            <h3>{{ getScenario.reporting_all_self_evaluations_title }}</h3>
            <div
              v-if="getScenario.reporting_all_self_evaluations_description"
              v-html="getScenario.reporting_all_self_evaluations_description"
              style="max-width: 900px"
            />
            <br />
            <br />

            <div>
              <div class="row flex-nowrap">
                <div class="col-wider-fixed-width"></div>
                <div
                  v-for="aCase in getCasesInTeamSelfawarenessOrder"
                  class="small col-fixed-width-header-align vertical"
                  :style="getVerticalTextStyle"
                  :key="aCase.case"
                >
                  {{ getShortNameByCaseNumber(aCase.caseNumber) }}
                </div>
              </div>
              <br />

              <div v-for="player in getPlayers" :key="player.id">
                <div class="row flex-nowrap">
                  <div class="small col-wider-fixed-width">
                    {{ player.nick_name }}
                  </div>

                  <div
                    v-for="evaluation in somePlayersSelfEvaluationsInTeamSelfawarenessOrder(
                      player.id
                    )"
                    class="small col-fixed-width"
                    v-bind:style="getBackgroundColor(evaluation.priority - 1)"
                    :key="evaluation.id"
                  >
                    <div class="text-center" :style="getTextColor(evaluation.priority - 1)">
                      {{ $store.getters.getNumberOfCases - evaluation.priority + 1 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <div style="max-width: 600px">
              <SelfEvaluationColorbar :forceNumbers="true" />
            </div>

            <br />
            <br />
          </div>

          <div v-if="$store.state.main.game.enableSurvey">
            <div v-if="showText" style="max-width: 900px">
              <h3 style="page-break-before: always">
                {{ getScenario.reporting_survey_answers_graph_title }}
              </h3>
              <div
                v-if="getScenario.reporting_survey_answers_graph_description"
                v-html="getScenario.reporting_survey_answers_graph_description"
                style="max-width: 900px"
              />
            </div>
            <br />

            <ECharts
              :initOptions="initOptions"
              ref="surveyAnswers"
              :options="surveyAnswersOptions"
              :autoresize="!printMode"
              :style="getEChartsStyle()"
            />

            <img
              :key="'surveyAnswers' + imagesComponentKey"
              v-if="printMode && printImagesReady"
              :src="surveyAnswersImage(imagesComponentKey)"
              width="1000"
            />

            <h3 style="page-break-before: always">
              {{ getScenario.reporting_survey_answers_text_title }}
            </h3>
            <div
              v-if="getScenario.reporting_survey_answers_text_description"
              v-html="getScenario.reporting_survey_answers_text_description"
              style="max-width: 900px"
            />

            <br />
            {{ $t("scale") }}: 1 - {{ $store.state.main.game.surveyScale }}
            <br />
            <br />

            <div v-if="showText">
              <div v-for="(average) in sortedAverages" :key="average.case.id">
                <strong>{{ getShortName(average.case.case) }}</strong>
                <div>
                  {{ surveyQuestion(2, average.case) }}
                  <b>{{ surveyAverage(2, average.case) }}</b> ({{ $t("lowest") }}:
                  {{ survey2Lowest[average.case.caseNumber] }} - {{ $t("highest") }}:
                  {{ survey2Highest[[average.case.caseNumber]] }})
                  <br />
                </div>
                <div>
                  {{ surveyQuestion(1, average.case) }}
                  <b>{{ surveyAverage(1, average.case) }}</b> ({{ $t("lowest") }}:
                  {{ survey1Lowest[average.case.caseNumber] }} - {{ $t("highest") }}:
                  {{ survey1Highest[[average.case.caseNumber]] }})
                  <br />
                </div>
              </div>
            </div>
            <br />
          </div>

          <Suggestions v-if="showText" />

          <br />
          <div v-if="!printMode">
            <Feedback />
            <br />
            <br />
            <div v-if="$store.getters.getIsFacilitator">
              <hr />
              <FacilitatorFeedback />
              <br />
              <br />
            </div>
          </div>

          <div
            v-if="
              showText &&
                $store.getters.getIsFacilitator &&
                !$store.state.main.playerIsObserver &&
                this.selectedPlayer === 0
            "
          >
            <h3 style="page-break-before: always">{{ $t("allrelations") }}</h3>
            <div v-for="(aCase, index) in getCases" :key="aCase.case">
              <div style="page-break-before: always" v-if="pageBreak(index)"></div>
              <strong>{{ getCaseNumber(aCase.case) }}. {{ getShortName(aCase.case) }}</strong>
              <RelationsCytoscape
                initialCanvasWidth="550"
                :selectedCaseNumber="getCaseNumber(aCase.case)"
              />
            </div>
            <br />
            <div v-if="$store.state.main.game.enableComments">
              <h3 style="page-break-before: always">{{ $t("allcomments") }}</h3>
              <div v-for="(aCase) in getCases" :key="aCase.case">
                <strong>{{ getCaseNumber(aCase.case) }}. {{ getShortName(aCase.case) }}</strong>
                <div v-for="comments in getComments(getCaseNumber(aCase.case))" :key="comments.id">
                  {{ comments.comment }}
                  <br />
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
        <div class="noprint">
          <FacilitatorTools
            v-if="
              $store.getters.getIsFacilitator && !$store.state.main.playerIsObserver && showChart
            "
          ></FacilitatorTools>
          <br />
        </div>
      </div>
    </div>
  </ReportingLayout>
</template>

<script>
// https://forum.vuejs.org/t/using-v-for-with-bootstrap-grid-system/16093/2?u=tputkonen

import ECharts from "vue-echarts";
import LocaleChanger from "@/components/LocaleChanger.vue";
import {
  getAndCommitGameByGameCode,
  getAndCommitScenario,
  getAndCommitCases,
  getAndCommitNominationsByGame,
  getAndCommitPlayersByGame,
  getAndCommitSelfEvaluationsByGame,
  getGameByReportingCode,
  getPlayerByReportingCode,
  getAndCommitCommentsByGame,
  getSurveyAverage,
  getAndCommitSuggestionsByGame,
  getThisAdminInformation,
  getPlayerByFacilitatorId
} from "../services/APIService";
import FacilitatorTools from "@/components/FacilitatorTools.vue";
import Feedback from "@/components/Feedback.vue";
import FacilitatorFeedback from "@/components/FacilitatorFeedback.vue";
import ActionPlan from "@/components/ActionPlan/ActionPlan.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/scatter";
import "echarts/lib/chart/graph";
import "echarts/lib/chart/gauge";
import "echarts/lib/component/legend";
// https://stackoverflow.com/a/65154531/76535
import RelationsCytoscape from "@/components/RelationsCytoscape.vue";
import { generateExcelExport } from "../services/ExcelExport";
import { getSurveyQuestion, generateSurveyDescriptionString } from "../services/utils.js";
import ReportingLayout from "@/layouts/ReportingLayout.vue";
import SelfEvaluationColorbar from "../components/SelfEvaluationColorbar.vue";
import NetworkError from "@/components/NetworkError.vue";
import Logo from "@/components/Logo.vue";
import Suggestions from "@/components/charts/Suggestions.vue";

const cloneDeep = require("lodash.clonedeep");
const chunk = require("lodash.chunk");
const zip = require("lodash.zip");

export default {
  components: {
    LocaleChanger,
    ECharts,
    FacilitatorTools,
    RelationsCytoscape,
    ReportingLayout,
    Feedback,
    SelfEvaluationColorbar,
    NetworkError,
    FacilitatorFeedback,
    Logo,
    Suggestions,
    ActionPlan
  },

  data() {
    return {
      showChart: false,
      teamSelfAwareness: 0,
      selectedPlayerTeamSelfAwareness: 0,
      teamSelfAwarenessOptions: null,
      selectedPlayerTeamSelfAwarenessOptions: null,
      calculatedConnectivity: null,
      connectivityOptions: null,
      selfAwarenessStatistics: null,
      sortedSelfAwarenessStatistics: null,
      minMaxOptions: null,
      teamMostLikedOptions: null,
      reportingCodeReceived: false,
      gameCodeReceived: false,
      selectedPlayer: 0, // 0 = facilitator
      surveyAnswers: [],
      printMode: false,
      printImagesReady: false,
      initOptions: {
        renderer: "canvas"
      },
      imagesComponentKey: 0,
      localeKey: 0,
      survey1Averages: [],
      survey1Lowest: [],
      survey1Highest: [],
      survey2Averages: [],
      survey2Lowest: [],
      survey2Highest: [],
      surveyAnswersOptions: null,
      sortedAverages: []
    };
  },
  computed: {
    getScenario() {
      return this.$store.getters.getScenarioInCurrentLocale;
    },
    gameName() {
      return this.$store.state.main.game.name;
    },
    openDate() {
      return new Date(this.$store.state.main.game.opened).toLocaleDateString(this.$i18n.locale);
    },
    playerName() {
      const player = this.$store.getters.getPlayerById(this.selectedPlayer);

      return player.first_name + " " + player.last_name + " (" + player.nick_name + ")";
    },
    getPlayers() {
      return this.$store.getters.getPlayers;
    },
    getLocale() {
      return this.$i18n.locale;
    },
    playerSelfEvaluations() {
      const evaluations = cloneDeep(
        this.$store.getters.getSomePlayersSelfEvaluations(this.selectedPlayer)
      );

      // Sort by priority
      evaluations.sort((x, y) => {
        if (x.priority < y.priority) {
          return -1;
        } else {
          return 1;
        }
      });

      return evaluations;
    },
    playerNominations() {
      // Let's return this players' nominations in sorted (team's preferences)
      const myNominations = [];

      for (let i = this.sortedSelfAwarenessStatistics.length - 1; i >= 0; i--) {
        const stat = this.sortedSelfAwarenessStatistics[i];

        const aCase = this.$store.getters.getCaseByCaseId(stat.case);

        const nomination = this.$store.getters.getSomePlayersNominationForCase(
          this.selectedPlayer,
          aCase.caseNumber
        );
        if (nomination) {
          myNominations.push(nomination);
        }
      }

      return myNominations;
    },
    getCases() {
      return this.$store.getters.getCasesInCurrentLocale;
    },
    getCasesInTeamSelfawarenessOrder() {
      const returnCases = [];
      for (let i = this.sortedSelfAwarenessStatistics.length - 1; i >= 0; i--) {
        const stat = this.sortedSelfAwarenessStatistics[i];
        const aCase = this.$store.getters.getCaseByCaseId(stat.case);
        returnCases.push(aCase);
      }
      return returnCases;
    },
    allNominations() {
      // Let's return all players' nominations in sorted order
      const allNominations = [];

      for (let i = 1; i <= this.$store.getters.getNumberOfCases; i++) {
        const nominations = this.$store.getters.getNominationsForCase(i);

        if (nominations) {
          allNominations.push(nominations);
        }
      }
      return allNominations;
    },
    showText() {
      // If print mode, don't show text before images are ready
      if (!this.printMode) {
        return true;
      } else {
        return this.printImagesReady;
      }
    },
    surveyDescription() {
      return generateSurveyDescriptionString(this.$store);
    },
    getUrl() {
      return window.location.href + "/print/1";
    },
    getVerticalTextStyle() {
      // Let's do some CSS magic for Korean text
      if (this.$i18n.locale === "ko") {
        return "writing-mode: vertical-rl; transform: rotate(360deg);";
      } else {
        return "";
      }
    }
  },
  watch: {
    getLocale: {
      handler(newData, oldData) {
        if (this.showChart) {
          this.generateCharts();
        }
      }
    }
  },
  async created() {
    this.printMode = this.$route.params.print;

    if (this.$route.params.reportingcode) {
      // Personal reporting code included in URL
      this.reportingCodeReceived = true;

      const reportingCode = this.$route.params.reportingcode;
      const resp = await getGameByReportingCode(reportingCode);

      if (resp.game_code) {
        // Correct code
        this.$store.commit({
          type: "setThisGameCode",
          gameCode: resp.game_code
        });

        this.$store.commit({
          type: "setThisGameId",
          gameCode: resp.id
        });

        // We also need to get the player id
        const playerResp = await getPlayerByReportingCode(reportingCode);

        this.$store.commit({
          type: "setThisPlayerId",
          playerId: playerResp.id
        });
      } else {
        // Wrong reporting code
        this.$router.push("/");
      }
    }

    if (
      this.$route.params.gamecode &&
      this.$store.getters.getIsFacilitator &&
      !this.$store.state.main.playerIsObserver
    ) {
      this.$store.commit("reinitializeStore");
      this.gameCodeReceived = true;

      // Only facilitator can show the reporting with gamecode in URL
      this.$store.commit({
        type: "setThisGameCode",
        gameCode: this.$route.params.gamecode
      });
    } else if (!this.$store.state.main.game.gameCode) {
      // Not allowed to show
      this.$router.push("/");
    }

    // Let's set thisPlayerId if facilitator
    // has opened to report from game list.
    if (this.$store.getters.getIsFacilitator && !this.$store.state.main.thisPlayerId) {
      // Get facilitator information and fill fields
      getThisAdminInformation().then(resp => {
        // Let's first check if the facilitator has already played this game...
        getPlayerByFacilitatorId(this.$store.state.main.game.gameCode, resp.id).then(player => {
          if (player) {
            this.$store.dispatch("log", "Existing facilitator player found: " + player.id);

            this.$store.commit({
              type: "setThisPlayerId",
              playerId: player.id
            });
          }
        });
      });
    }

    this.$store.dispatch("connectNotification");
    this.$store.dispatch("updateGame");

    this.updateData();
  },
  mounted() {},
  methods: {
    somePlayersSelfEvaluationsInTeamSelfawarenessOrder(playerId) {
      const evaluations = [];

      for (let i = this.sortedSelfAwarenessStatistics.length - 1; i >= 0; i--) {
        const stat = this.sortedSelfAwarenessStatistics[i];

        const aCase = this.$store.getters.getCaseByCaseId(stat.case);

        const evaluation = this.$store.getters.getSomePlayersSelfEvaluationsForCase(
          playerId,
          aCase.caseNumber
        );

        if (evaluation) {
          evaluations.push(evaluation);
        }
      }
      return evaluations;
    },
    getNick(playerId) {
      return this.$store.getters.getPlayerById(playerId).nick_name;
    },
    getQuestion(caseId) {
      const theCase = this.$store.getters.getCaseByCaseId(caseId);

      return theCase.selfEvaluationQuestion;
    },
    getShortName(caseId) {
      const theCase = this.$store.getters.getCaseByCaseId(caseId);

      return theCase.shortName;
    },
    getShortNameByCaseNumber(caseNumber) {
      const theCase = this.$store.getters.getCaseByCaseNumber(caseNumber);

      return theCase.shortName;
    },
    getTitle(caseId) {
      const theCase = this.$store.getters.getCaseByCaseId(caseId);

      return theCase.title;
    },
    getCaseNumber(caseId) {
      const theCase = this.$store.getters.getCaseByCaseId(caseId);
      return theCase.caseNumber;
    },
    getComments(caseNumber) {
      return this.$store.getters.getCommentsByCaseNumber(caseNumber);
    },
    getBackgroundColor(index) {
      return "background-color: " + this.$store.state.main.colors[index];
    },
    getTextColor(index) {
      return "color: " + this.$store.state.main.textColors[index];
    },
    getNominations(caseNumber) {
      return this.$store.getters.getNominationsForCase(caseNumber);
    },
    async generateCharts() {
      if (this.printMode) {
        this.printImagesReady = false;
        this.showChart = false;
        // Force regeneration of images:
        this.imagesComponentKey++;
      }
      await this.$store.dispatch({
        type: "initializeColors"
      });
      // Call this when all data is in Vuex
      this.calculateTeamSelfAwarenessStatistics();
      this.calculateConnectivity();
      this.generateConnectivityOptions();
      this.teamSelfAwarenessOptions = this.generateSelfAwarenessOptions(this.teamSelfAwareness);
      if (this.selectedPlayer) {
        this.selectedPlayerTeamSelfAwarenessOptions = this.generateSelfAwarenessOptions(
          this.selectedPlayerTeamSelfAwareness
        );
      }
      this.generateMinMaxOptions();
      this.generateTeamMostLikedOptions();
      this.generateSurveyAnswersOptions();
      this.showChart = true;

      // Let's wait a couple of seconds before showing images. Otherwise the charts will not be ready.

      if (this.printMode) {
        setTimeout(() => {
          this.printImagesReady = true;
        }, 3000);
      }
    },
    generateConnectivityOptions() {
      // Generates "spider web" chart.
      // https://echarts.apache.org/examples/en/editor.html?c=graph-simple
      // First let's create an array of all nicks
      const data = [];
      const links = [];

      this.$store.state.main.allPlayers.forEach(player => {
        data.push({ name: player.nick_name });
      });

      // Then links
      const entries = Object.entries(this.calculatedConnectivity);

      for (let i = 0; i < entries.length; i++) {
        const key = entries[i][0]; // Key formatting: player_id,player_id
        const value = entries[i][1];

        const players = key.split(",");
        const p1Id = players[0];
        const p2Id = players[1];

        const p1Nick = this.$store.getters.getPlayerById(p1Id).nick_name;
        const p2Nick = this.$store.getters.getPlayerById(p2Id).nick_name;

        const newLink = {
          source: p1Nick,
          target: p2Nick,
          lineStyle: {
            normal: {
              width: this.printMode ? value * 4 : value * 2
            }
          }
        };

        links.push(newLink);
      }

      this.connectivityOptions = {
        animation: false,
        tooltip: {
          show: false
        },
        series: [
          {
            animation: false,
            hoverAnimation: false,
            legendHoverLink: false,
            silent: true,
            type: "graph",
            layout: "circular",
            symbolSize: 1,
            label: {
              normal: {
                color: "#000000",
                show: true,
                fontSize: this.printMode ? 32 : 16,
                fontFamily: "Open Sans",
                fontWeight: "bold"
              }
            },
            lineStyle: {
              color: "#63869e"
            },
            data: data,
            links: links,
            left: 30,
            right: 30,
            top: 30,
            bottom: 30
          }
        ]
      };
    },
    generateMinMaxOptions() {
      // https://echarts.apache.org/examples/en/editor.html?c=bar-waterfall2
      // https://echarts.apache.org/examples/en/editor.html?c=scatter-simple

      const mins = [];
      const maxs = [];
      const axis = [];
      const scatter = [];

      const cases = this.$store.getters.getNumberOfCases;

      this.sortedSelfAwarenessStatistics.forEach(minMax => {
        const { min } = minMax;
        const { max } = minMax;
        let difference = max - min;

        let newMin = cases + 1 - max;

        if (difference === 0) {
          // If there's no difference, let's make some.
          // Otherwise there will be no visible bar.
          newMin -= 0.1;
          difference = 0.2;
        }

        maxs.push(newMin);
        //mins.push(difference);

        const color = this.$store.state.main.colors[Math.round(minMax.average) - 1];

        const newItem = {
          value: difference,
          //itemStyle: { "color": color, "borderColor": 'black', "borderWidth": '1' },
          itemStyle: {
            color: "#63869e",
            borderColor: "black",
            borderWidth: "1"
          }
        };

        mins.push(newItem);

        const thisCase = this.$store.getters.getCaseByCaseId(minMax.case);
        axis.push(thisCase.shortName + " ");
        // Let's add an extra space, otherwise scatter on 1 will come on top of the axis text

        if (this.selectedPlayer !== 0) {
          const evaluation = this.$store.getters.getSomePlayersSelfEvaluationsForCase(
            this.selectedPlayer,
            thisCase.caseNumber
          );

          scatter.push(this.$store.getters.getNumberOfCases - evaluation.priority + 1);
        }
      });

      if (this.selectedPlayer !== 0) {
        // Show player's self evaluations as scatter
        for (let i = 1; i <= this.$store.getters.getNumberOfCases; i++) {
          const evaluation = this.$store.getters.getSomePlayersSelfEvaluationsForCase(
            this.selectedPlayer,
            i
          );
        }
      }

      const lessMoreLabels = this.generateLessMoreLabels();

      this.minMaxOptions = {
        animation: false,
        tooltip: {
          show: false
        },
        grid: {
          containLabel: true
        },
        yAxis: {
          type: "category",
          data: axis,
          axisLabel: {
            show: true,
            interval: 0,
            fontFamily: "Open Sans",
            fontSize: this.printMode ? 28 : 14
          },
          axisTick: {
            show: true,
            interval: 0
          }
        },
        xAxis: [
          {
            type: "value",
            position: "bottom",
            data: axis,
            min: 1,
            minInterval: 1,
            maxInterval: 1,
            max: this.$store.getters.getNumberOfCases,
            axisTick: {
              interval: 1
            },
            axisLabel: {
              fontFamily: "Open Sans",
              fontSize: this.printMode ? 28 : 14
            }
          },
          {
            type: "category",
            position: "bottom",
            data: lessMoreLabels,
            offset: this.printMode ? 40 : 20,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              fontFamily: "Open Sans",
              fontSize: this.printMode ? 28 : 14
            }
          }
        ],
        series: [
          {
            silent: true,
            type: "bar",
            stack: "minmax",
            itemStyle: {
              normal: {
                color: "rgba(0,0,0,0)"
              }
            },
            data: maxs
          },
          {
            silent: true,
            type: "bar",
            stack: "minmax",
            data: mins
          },
          {
            silent: true,
            symbolSize: this.printMode ? 30 : 15,
            data: scatter,
            type: "scatter",
            itemStyle: { color: "black" }
          }
        ]
      };
    },
    generateTeamMostLikedOptions() {
      const yAxis = [];
      const maxs = [];

      // Let's sort by average:
      const sortedMinMax = cloneDeep(this.selfAwarenessStatistics).sort((a, b) => {
        return b.average - a.average;
      });

      sortedMinMax.forEach((minMax, index) => {
        const color = this.$store.state.main.colors[Math.round(minMax.average) - 1];

        const newItem = {
          value: this.$store.getters.getNumberOfCases - minMax.average + 1,
          itemStyle: { color: color, borderColor: "black", borderWidth: "1" }
        };

        maxs.push(newItem);
        const thisCase = this.$store.getters.getCaseByCaseId(minMax.case);
        yAxis.push(thisCase.shortName);
      });

      const lessMoreLabels = this.generateLessMoreLabels();

      this.teamMostLikedOptions = {
        animation: false,
        tooltip: {
          show: false
        },
        yAxis: {
          data: yAxis,
          axisLabel: {
            fontFamily: "Open Sans",
            fontSize: this.printMode ? 28 : 14
          }
        },
        grid: {
          left: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "value",
            position: "bottom",
            min: 0,
            max: this.$store.getters.getNumberOfCases,
            interval: 1,
            axisLabel: {
              fontFamily: "Open Sans",
              fontSize: this.printMode ? 28 : 14
            }
          },
          {
            type: "category",
            position: "bottom",
            data: lessMoreLabels,
            offset: this.printMode ? 30 : 15,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              fontFamily: "Open Sans",
              fontSize: this.printMode ? 24 : 12
            }
          }
        ],
        series: [
          {
            silent: true,
            type: "bar",
            data: maxs
          }
        ]
      };
    },
    generateSelfAwarenessOptions(gaugeValue) {
      return {
        animation: false,
        tooltip: {
          show: false
        },
        series: [
          {
            silent: true,
            tooltip: {
              show: false
            },
            type: "gauge",
            detail: {
              fontFamily: "Open Sans",
              fontSize: this.printMode ? 50 : 25,
              formatter: "{value}%"
            },
            data: [{ value: gaugeValue }],
            axisLabel: {
              fontFamily: "Open Sans",
              fontSize: this.printMode ? 30 : 15
            },
            splitLine: {
              length: this.printMode ? 60 : 30,
              lineStyle: {
                width: this.printMode ? 4 : 2
              }
            },
            axisTick: {
              length: this.printMode ? 16 : 8,
              lineStyle: {
                width: this.printMode ? 2 : 1
              }
            },
            pointer: {
              width: this.printMode ? 16 : 8
            },
            axisLine: {
              lineStyle: {
                color: [
                  [0.4, "#c23531"],
                  [0.7, "#63869e"],
                  [1, "#91c7ae"]
                ],
                width: this.printMode ? 60 : 30
              }
            }
          }
        ]
      };
    },
    selectedTeamSelfEvaluations() {
      const cases = this.$store.getters.getNumberOfCases;

      const formattedEvaluations = [];

      const sortedStatistics = cloneDeep(this.selfAwarenessStatistics).sort((a, b) => {
        return a.average - b.average;
      });

      for (let i = 0; i < cases; i++) {
        const statistic = sortedStatistics[i];
        const aCase = this.$store.getters.getCaseByCaseId(statistic.case);
        const averageDecimal = (Math.round(10 * statistic.average) / 10).toFixed(1);
        const averageInteger = Math.round(averageDecimal);
        const reverseDecimal = (cases + 1 - averageDecimal).toFixed(1);
        const colorIndex = cases - Math.round(reverseDecimal);

        const newEvaluation = {
          caseId: statistic.case,
          index: i + 1,
          text: aCase.shortName + " (" + reverseDecimal + ")",
          backgroundColor: "background-color:" + this.$store.state.main.colors[colorIndex],
          textColor: "color:" + this.$store.state.main.textColors[colorIndex]
        };

        formattedEvaluations.push(newEvaluation);
      }

      const pickedEvaluations = [];

      for (let i = 0; i < 3; i++) {
        pickedEvaluations.push(formattedEvaluations[i]);
      }

      // ...then a placeholder...
      const newEvaluation = {
        caseId: -1,
        priority: "   ",
        text: "...",
        backgroundColor: "background-color:white",
        textColor: "color:black"
      };
      pickedEvaluations.push(newEvaluation);
      // ...finally, bottom three

      const last = formattedEvaluations.length;

      for (let i = last - 3; i < last; i++) {
        pickedEvaluations.push(formattedEvaluations[i]);
      }
      return pickedEvaluations;
    },
    async updateData() {
      // Read data to Vuex
      await getAndCommitGameByGameCode(this.$store.state.main.game.gameCode, this.$store.commit);

      await getAndCommitScenario(
        this.$store.state.main.game.scenario,
        this.$store.state.main.game.gameCode,
        this.$store.commit
      );

      await getAndCommitCases(
        this.$store.state.main.game.scenario,
        this.$store.state.main.game.gameCode,
        this.$store.commit
      );

      await this.$store.dispatch("updateActionPlanVotes");

      const p1 = getAndCommitPlayersByGame(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.$store.commit
      );

      const p2 = getAndCommitSelfEvaluationsByGame(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.$store.commit
      );

      const p3 = getAndCommitNominationsByGame(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.$store.commit
      );

      const p4 = getAndCommitSuggestionsByGame(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.$store.commit
      );

      if (
        this.$store.state.main.game.enableComments &&
        this.$store.getters.getIsFacilitator &&
        !this.$store.state.main.playerIsObserver
      ) {
        await getAndCommitCommentsByGame(
          this.$store.state.main.game.id,
          this.$store.state.main.game.gameCode,
          this.$store.commit
        );
      }

      const surveyPromises = [];

      if (this.$store.state.main.game.enableSurvey) {
        const cases = this.$store.getters.getCasesInCurrentLocale;

        for (let i = 0; i < cases.length; i++) {
          const aCase = cases[i];

          surveyPromises.push(
            getSurveyAverage(
              this.$store.state.main.game.id,
              aCase.case,
              1,
              this.$store.state.main.game.gameCode
            ).then(data => {
              this.survey1Averages[aCase.caseNumber] = data.average.toFixed(1);
              this.survey1Lowest[aCase.caseNumber] = data.lowest_value;
              this.survey1Highest[aCase.caseNumber] = data.highest_value;
            })
          );

          surveyPromises.push(
            getSurveyAverage(
              this.$store.state.main.game.id,
              aCase.case,
              2,
              this.$store.state.main.game.gameCode
            ).then(data => {
              this.survey2Averages[aCase.caseNumber] = data.average.toFixed(1);
              this.survey2Lowest[aCase.caseNumber] = data.lowest_value;
              this.survey2Highest[aCase.caseNumber] = data.highest_value;
            })
          );
        }
      }

      Promise.all([p1, p2, p3, p4].concat(surveyPromises)).then(resp => {
        if (!this.printMode && (this.reportingCodeReceived || this.gameCodeReceived)) {
          // If reporting was activated using URL which has reporting or game code link, set locale to game's
          // default locale. Later, if Player model gets selected locale field, we can use that.
          // However, if in print mode, don't change locale

          this.$store.commit("setGameLocales");

          this.$store.commit({
            type: "setSelectedLocale",
            selectedLocale: this.$store.state.main.game.defaultLocale
          });

          this.$i18n.locale = this.$store.state.main.game.defaultLocale;

          // Force updating locale changer
          this.localeKey++;
        }

        if (!this.$store.state.main.thisPlayerId) {
          // No player id -> facilitator only
          this.$store.commit({
            type: "setPlayerIsOnlyFacilitator",
            playerIsOnlyFacilitator: true
          });
        } else {
          this.selectedPlayer = this.$store.state.main.thisPlayerId;
        }
        this.generateCharts();
      });
    },
    calculateConnectivity() {
      const map = {};

      // Let's create a map which calcalutes connections between two players
      this.$store.state.main.nominations.forEach(nomination => {
        const { player } = nomination;
        const { nominee } = nomination;

        let key;

        // Let's always add lower id first

        if (player < nominee) {
          key = player + "," + nominee;
        } else {
          key = nominee + "," + player;
        }

        let newValue = map[key];

        if (!newValue) {
          newValue = 0;
        }

        newValue++;

        map[key] = newValue;
      });

      this.calculatedConnectivity = map;
    },
    calculateTeamSelfAwarenessStatistics() {
      // Calculates team self awareness %, as well as min and max for each case and averages
      // Generates an array in the order of cases in the game, and also another array sorted by priority.

      const cases = this.$store.getters.getNumberOfCases;

      const percentages = [];
      const selectedPlayerPercentages = [];
      const statistics = [];

      for (let i = 1; i <= cases; i++) {
        const aCase = this.$store.getters.getCaseByCaseNumber(i);

        // All self evaluations for this case:
        const selfEvaluations = this.$store.getters.getSelfEvaluationsByCaseNumber(i);

        // Let's create an array of all priorities
        const priorities = [];

        let sum = 0;

        selfEvaluations.forEach(evaluation => {
          priorities.push(evaluation.priority);
          sum += evaluation.priority;
        });

        const average = sum / selfEvaluations.length;

        // Sort the priorities. Priorities are strings.
        const sortedPriorities = priorities.sort((a, b) => {
          return a - b;
        });

        const max = sortedPriorities[sortedPriorities.length - 1];
        const min = sortedPriorities[0];

        const newStatistics = {
          case: aCase.case,
          max: max,
          min: min,
          average: average
        };

        statistics.push(newStatistics);

        // Then get nominations
        const caseNominations = this.$store.getters.getNominationsForCase(aCase.caseNumber);

        // And for all nominations, see the priority of the nominee
        caseNominations.forEach(nomination => {
          const nomineeSelfEvaluation = this.$store.getters.getSomePlayersSelfEvaluationsForCase(
            nomination.nominee,
            aCase.caseNumber
          );

          if (!nomineeSelfEvaluation) {
            // Selected someone who has not done self evaluation -> skip
            return; // Next forEach
          }

          const nomineePriority = nomineeSelfEvaluation.priority;

          let percentage = 0;

          if (min === max) {
            // Special case, no variation -> all nominations are 100 %
            percentage = 100;
          } else {
            percentage = 100 - ((nomineePriority - min) / (max - min)) * 100;
          }

          percentages.push(percentage);

          if (this.selectedPlayer === nomination.player) {
            selectedPlayerPercentages.push(percentage);
          }
        });
      }
      // Finally, let's calculate the averages
      this.teamSelfAwareness = this.calculateAverage(percentages);
      this.selectedPlayerTeamSelfAwareness = this.calculateAverage(selectedPlayerPercentages);

      this.selfAwarenessStatistics = statistics;

      this.sortedSelfAwarenessStatistics = cloneDeep(this.selfAwarenessStatistics).sort((a, b) => {
        return b.average - a.average;
      });
    },
    calculateAverage(percentages) {
      // Calculates average of array and rounds.
      if (!percentages.length) {
        return 0;
      }

      let sum = 0;
      percentages.forEach(percentage => {
        sum += percentage;
      });

      const total = sum / percentages.length;
      return Math.round(total);
    },
    openPrintDialog() {
      window.print();
    },

    exportToExcel() {
      generateExcelExport(this.$store, this.survey1Averages, this.survey2Averages);
    },

    hasSelectedPlayerBeenNominated() {
      const { nominations } = this.$store.state.main;

      for (let i = 0; i < nominations.length; i++) {
        if (nominations[i].nominee === this.selectedPlayer) {
          return true;
        }
      }

      return false;
    },

    getNumberOfNominationsText(caseId) {
      let count = 0;
      const theCase = this.$store.getters.getCaseByCaseId(caseId);
      const nominations = this.$store.getters.getNominationsForCase(theCase.caseNumber);

      if (nominations) {
        for (let i = 0; i < nominations.length; ++i) {
          if (nominations[i].nominee === this.selectedPlayer) {
            count++;
          }
        }
      }

      if (count > 0) {
        return "(" + count + ")";
      } else {
        return "";
      }
    },

    dropdowntext() {
      if (!this.selectedPlayer) {
        return this.$t("facilitator-report");
      } else {
        return this.$store.getters.getPlayerById(this.selectedPlayer).nick_name;
      }
    },

    facilitatorDropdownText() {
      return this.$t("facilitator-report");
    },

    pageBreak(index) {
      // For the relations graphs, insert page break after every third chart
      if (index > 0 && index % 3 === 0) {
        return true;
      } else {
        return false;
      }
    },
    surveyQuestion(surveyNumber, aCase) {
      return getSurveyQuestion(surveyNumber, aCase.caseNumber, this.$store);
    },
    surveyQuestionByCaseNumber(surveyNumber, caseNumber) {
      return getSurveyQuestion(surveyNumber, caseNumber, this.$store);
    },
    surveyAverage(surveyNumber, aCase) {
      // For players we have stored averages
      if (surveyNumber === 1) {
        return this.survey1Averages[aCase.caseNumber];
      } else {
        return this.survey2Averages[aCase.caseNumber];
      }
    },
    getScaleText() {
      return (
        "1 = " +
        this.$store.getters.getScenarioInCurrentLocale.self_evaluation_unpreferred +
        " - " +
        this.$store.getters.getNumberOfCases +
        " = " +
        this.$store.getters.getScenarioInCurrentLocale.self_evaluation_preferred
      );
    },
    getEChartsStyle() {
      if (this.printMode) {
        return {
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "2000px",
          height: "1000px"
        };
      } else {
        return { width: "100%", "max-width": "1000px", height: "500px" };
      }
    },
    teamSelfAwarenessImage(foo) {
      const chart = this.$refs.teamSelfAwareness;

      return chart.getDataURL({
        pixelRatio: 1
      });
    },
    selectedPlayerTeamSelfAwarenessImage(foo) {
      const chart = this.$refs.selectedPlayerTeamSelfAwareness;
      return chart.getDataURL({
        pixelRatio: 1
      });
    },
    teamMostLikedImage(foo) {
      const chart = this.$refs.teamMostLiked;
      return chart.getDataURL({
        pixelRatio: 1
      });
    },
    connectivityImage(foo) {
      const chart = this.$refs.connectivity;
      return chart.getDataURL({
        pixelRatio: 1
      });
    },
    minMaxImage(foo) {
      const chart = this.$refs.minMax;
      return chart.getDataURL({
        pixelRatio: 1
      });
    },
    surveyAnswersImage(foo) {
      const chart = this.$refs.surveyAnswers;
      return chart.getDataURL({
        pixelRatio: 1
      });
    },
    generateLessMoreLabels() {
      const lessMoreLabels = [];
      lessMoreLabels.push(
        this.$store.getters.getScenarioInCurrentLocale.self_evaluation_unpreferred
      );
      lessMoreLabels.push("");
      lessMoreLabels.push(this.$store.getters.getScenarioInCurrentLocale.self_evaluation_preferred);

      return lessMoreLabels;
    },
    generateSurveyAnswersOptions() {
      const averages = [];

      for (let i = 0; i < this.getCases.length; i++) {
        const aCase = this.getCases[i];
        const newAverage = {
          case: aCase,
          caseNumber: aCase.caseNumber,
          caseName: aCase.shortName,
          average1: this.surveyAverage(1, aCase),
          average2: this.surveyAverage(2, aCase)
        };

        averages.push(newAverage);
      }

      // Let's sort averages by priority (= question 2)
      this.sortedAverages = cloneDeep(averages).sort((a, b) => {
        return b.average2 - a.average2;
      });

      const yAxis = [];
      const average1Series = [];
      const average2Series = [];

      for (let i = this.sortedAverages.length - 1; i >= 0; i--) {
        const average = this.sortedAverages[i];
        yAxis.push(average.caseName);
        average1Series.push(average.average1);
        average2Series.push(average.average2);
      }

      this.surveyAnswersOptions = {
        animation: false,
        tooltip: {
          show: false
        },
        legend: {
          textStyle: {
            fontFamily: "Open Sans",
            fontSize: this.printMode ? 28 : 14
          }
        },
        grid: {
          left: "10%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          min: 0,
          minInterval: 1,
          maxInterval: 1,
          max: this.$store.state.main.game.surveyScale,
          axisTick: {
            interval: 1
          },
          axisLabel: {
            fontFamily: "Open Sans",
            fontSize: this.printMode ? 28 : 14
          }
        },
        yAxis: {
          type: "category",
          data: yAxis,
          axisLabel: {
            fontFamily: "Open Sans",
            fontSize: this.printMode ? 28 : 14
          }
        },
        series: [
          {
            animation: false,
            hoverAnimation: false,
            legendHoverLink: false,
            silent: true,
            name:
              this.$t("answer2legend") +
              " (1 = " +
              this.getScenario.survey_question_2_minimum_value_label +
              ", " +
              this.$store.state.main.game.surveyScale +
              " = " +
              this.getScenario.survey_question_2_maximum_value_label +
              ")",
            type: "bar",
            data: average2Series,
            itemStyle: {
              color: "#ccccff",
              borderColor: "black",
              borderWidth: "1"
            }
          },
          {
            animation: false,
            hoverAnimation: false,
            legendHoverLink: false,
            silent: true,
            name:
              this.$t("answer1legend") +
              " (1 = " +
              this.getScenario.survey_question_1_minimum_value_label +
              ", " +
              this.$store.state.main.game.surveyScale +
              " = " +
              this.getScenario.survey_question_1_maximum_value_label +
              ")",
            type: "bar",
            data: average1Series,
            itemStyle: {
              color: "#63869e",
              borderColor: "black",
              borderWidth: "1"
            }
          }
        ]
      };
    }
  }
};
</script>
<i18n>
{
  "en": {
    "report": "Report",
    "loading": "Generating reports...",
    "diversityscatter": "Black dot shows your own self-evaluation.",
    "diversitybar": "Bar shows how diverse the team's answers are.",
    "playerselfevaluations": "Your self-evaluations",
    "yournominations": "Your nominations in different cases",
    "widescreen": "Please use wide browser window so that the whole table fits on screen.",
    "name": "Name:",
    "date": "Date:",
    "print": "Print...",
    "playernominations": "Number in parentheses shows how many colleagues nominated you for the case.",
    "facilitator-report": "Facilitator's report",
    "selectplayer-explanation": "Showing report of player:",
    "allrelations": "Graphs for all cases (only shown to facilitators)",
    "excel": "Export to Excel",
    "allcomments": "All comments (only shown to facilitators)",
    "generateprintablereport": "Generate printable report (opens in new tab)",
    "scale": "Scale",
    "reporthasbeenmailed": "A link to this report has been sent to you via email.",
    "answer1legend": "Perceived level",
    "answer2legend": "Perceived importance",
    "lowest": "lowest",
    "highest": "highest"
  },
  "fi": {
    "report": "Raportti",
    "loading": "Luon raportteja...",
    "diversityscatter": "Musta piste näyttää oman itsearviosi.",
    "diversitybar": "Palkki näyttää tiimin vastausten jakautumisen.",
    "playerselfevaluations": "Omat itsearviointisi",
    "yournominations": "Valitsemasi henkilöt",
    "evaluations": "Kaikki itsearvioinnit",
    "widescreen": "Käytäthän leveää selaimen ikkunaa, jotta koko taulukko mahtuu näyttöön.",
    "name": "Nimi:",
    "date": "Päiväys:",
    "print": "Tulosta...",
    "playernominations": "Suluissa oleva numero kertoo, miten monta kertaa sinut nimettiin kyseisessä tilanteessa.",
    "facilitator-report": "Pelinjohtajan yhteenveto",
    "selectplayer-explanation": "Osallistuja, jonka yhteenveto näytetään:",
    "allrelations": "Kaikkien tilanteiden kuvaajat (näkyy vain pelinjohtajalle)",
    "excel": "Vie Exceliin",
    "allcomments": "Kaikki kommentit (näkyy vain pelinjohtajalle)",
    "generateprintablereport": "Luo tulostettava raportti (aukeaa uuteen välilehteen)",
    "scale": "Asteikko",
    "reporthasbeenmailed": "Linkki tähän raporttiin on lähetetty sinulle sähköpostilla.",
    "answer1legend": "Arvioitu taso",
    "answer2legend": "Arvioitu tärkeys",
    "lowest": "alin",
    "highest": "korkein"     
  },
  "sv": {
    "report": "Rapporterna",
    "loading": "Skapar rapporter...",
    "diversityscatter": "Den svarta pricken visar din egen självskattning.",
    "diversitybar": "Stapeln visar hur gruppens variation i svaren.",
    "playerselfevaluations": "Din självskattning",
    "yournominations": "Personerna du valt",
    "evaluations": "Alla självskattningar",
    "widescreen": "Använd widescreen i webbläsarfönstret för att se hela tabellen.",
    "name": "Namn:",
    "date": "Datum:",
    "print": "Skriv ut...",
    "playernominations": "Siffran inom parentes visar hur många gånger du nämndes i den aktuella frågan.",
    "facilitator-report": "Spelledares sammanfattning",
    "selectplayer-explanation": "Deltagare vars sammanfattning kommer att visas:",
    "allrelations": "Grafer över alla situationer (endast synlig för spelledare)",
    "excel": "Exportera till Excel",
    "allcomments": "Alla kommentarer (endast synlig för spelledare)",
    "generateprintablereport": "Skapa rapporten i utskriftsformat (öppnas i en ny flik)",
    "scale": "Skala",
    "reporthasbeenmailed": "En länk till denna rapport har skickats till dig via e-post.",
    "answer1legend": "Upplevd nivå",
    "answer2legend": "Upplevd vikt",
    "lowest": "lägst",
    "highest": "högst"       
  },
  "de": {
    "report": "Berichte",
    "loading": "Berichte erstellen...",    
    "diversityscatter": "Der schwarze Punkt zeigt Ihre eigene Selbstbewertung.",
    "diversitybar": "Der Leiste zeigt, wie unterschiedlich die Antworten des Teams sind.",
    "playerselfevaluations": "Ihre Selbstevaluation",
    "yournominations": "Ihre Nominierungen in verschiedenen Fällen",
    "evaluations": "Alle Selbstevaluation",
    "widescreen": "Bitte verwenden Sie ein breites Browserfenster, damit die gesamte Tabelle auf den Bildschirm passt.",
    "name": "Name:",
    "date": "Datum:",
    "print": "Drucken...",
    "playernominations": "Die Zahl in Klammern gibt an, wie viele Kollegen Sie für den Fall nominiert haben.",
    "facilitator-report": "Bericht des Spielmanager",
    "selectplayer-explanation": "Anzeige des Spielerberichts:",
    "allrelations": "Grafiken für alle Fälle (werden nur den Spielmanager angezeigt)",
    "excel": "In Excel exportieren",
    "allcomments": "Alle Kommentare (werden nur den Spielmanager angezeigt)",
    "generateprintablereport": "Erstellen Sie einen Bericht zum Drucken (wird in einer neuen Tab geöffnet)",
    "scale": "Skala",
    "reporthasbeenmailed": "Ein Link zu diesem Bericht wurde Ihnen per E-Mail gesendet.",
    "answer1legend": "Wie gut geht es",
    "answer2legend": "Bedeutung",
    "lowest": "am niedrigsten",
    "highest": "höchste"
  },
  "ko": {
    "report": "결과보고서",
    "loading": "결과보고서를 로딩 중입니다.",
    "diversityscatter": "검은색 점은 본인진단 결과입니다.",
    "diversitybar": "막대 그래프는 팀원들의 다양한 응답 결과를 나타냅니다.",
    "playerselfevaluations": "본인진단 결과",
    "yournominations": "주제별 응답 결과",
    "evaluations": "본인진단 전체 결과",
    "widescreen": "화면에 전체 그래프가 보이도록 브라우저 크기를 넓혀주십시오. ",
    "name": "이름:",
    "date": "날짜:",
    "print": "인쇄",
    "playernominations": "괄호 안의 숫자는 나를 선택한 팀원의 수를 나타냅니다.",
    "facilitator-report": "퍼실리테이터 보고서",
    "selectplayer-explanation": "참여자 결과보고서 보기",
    "allrelations": "전체 그래프 (퍼실리테이터에게만 공개)",
    "excel": "엑셀파일로 다운받기",
    "allcomments": "전체 댓글 (퍼실리테이터에게만 공개)",
    "generateprintablereport": "새 탭에서 인쇄용 파일 열기",
    "scale": "범위",
    "reporthasbeenmailed": "개별 결과보고서를 확인할 수 있는 링크가 이메일로 전송되었습니다.",
    "answer1legend": "우리 팀이 인지하고 있는 현재 수준",
    "answer2legend": "우리 팀이 인지하고 있는 중요도"
  }
}
</i18n>

<style scoped>
iframe {
  width: 100%;
  max-width: 700px;
}

/* https://stackoverflow.com/a/40911154/76535 */
.vertical {
  writing-mode: tb-rl;
  transform: rotate(-180deg);
}

.self-evaluation {
  max-width: 900px;
  width: 100%;
}

.col-fixed-width {
  flex: 0 3 48px;
}

.col-fixed-width-header-align {
  flex: 0 3 48px;
  display: flex;
  align-items: center;
}

.col-wider-fixed-width {
  flex: 0 1 140px;
}

* {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari 6 – 15.3, Edge */
  color-adjust: exact !important; /* Firefox 48 – 96 */
  print-color-adjust: exact !important; /* Firefox 97+, Safari 15.4+ */
}

@media print {
  @page {
    margin: 1cm;
  }
  body {
    width: 210mm;
    height: 297mm;
    margin: 25mm 25mm 25mm 25mm;
  }
  .noprint {
    display: none !important;
  }
  .card {
    display: none !important;
  } /* hide facilitator toolbox */
}
</style>
